import { makeStyles } from "tss-react/mui";
import { TIMELINE_WIDTH } from "@miplatform/constants";
import { Box, Typography } from "@mui/material";
import type { TimeInterval } from "../types";

export function TimeGutter({
  intervals = [],
  adjustedHeight = 0,
  columnHeaderHeight = 0,
}: Readonly<TimeGutterProps>) {
  const { classes } = useStyles({ adjustedHeight, columnHeaderHeight });

  return (
    <Box className={classes.gutterContainer} data-testid="time-gutter">
      {intervals.map((interval) => (
        <Typography
          className={classes.hourBlock}
          key={interval.id}
          variant="body2"
        >
          {interval.time}
        </Typography>
      ))}
    </Box>
  );
}

const useStyles = makeStyles<{
  adjustedHeight: number;
  columnHeaderHeight: number;
}>()((theme, { adjustedHeight, columnHeaderHeight }) => ({
  gutterContainer: {
    flex: "0 0 auto",
    width: TIMELINE_WIDTH,
    backgroundColor: theme.palette.background.default,
    position: "sticky",
    left: 0,
    zIndex: theme.zIndex.base,
    marginTop: columnHeaderHeight,
  },
  hourBlock: {
    height: adjustedHeight,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    borderBottom: `1px solid grey`,
    fontSize: theme.fontSize.xsmall,
    "&:last-child": { borderBottomWidth: 0 },
  },
}));

export interface TimeGutterProps {
  intervals?: TimeInterval[];
  adjustedHeight?: number;
  columnHeaderHeight?: number;
}
